export default {
  functionKey: "CAR",
  title: "CAR",
  group: "Texte",
  origin: [],
  target: [],
  description: "Retourne le caractère correspondant à un code ASCII. (Ex: CAR(65) -> 'A')",
  isStarred: false,

  generate(destination, origin, args, isArgumentCol) {
    const code = `${destination} = String.fromCharCode(Number(${origin}));`;
    return { displayCode: code, safeCode: code };
  }
}
